import linkifyHtml from 'linkifyjs/html';

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'snLinkify' })
export class SnLinkifyPipe implements PipeTransform {
  public transform(str: string): string {
    return linkifyHtml(str);
  }
}
